import { cnpj } from "cpf-cnpj-validator";

export const isCNPJValidHelper = (value) => {
  const isValid = cnpj.isValid(value, false);

  return isValid;
}
